module.exports = __webpack_public_path__ + "img/fig03.bee8ab46.jpg";